import { useAppSelector } from "./useAppSelector";

export const useUser = () => {
  return useAppSelector(state => state.auth.user);
};
